import { lazy } from 'react';

export interface Routes {
  path: string;
  component: React.LazyExoticComponent<any>;
  children?: Routes[];
}

// 布局页面
const LayoutPage = lazy(() => import('@/layout'));
// 404页面
const NotFoundPage = lazy(() => import('@/pages/404'));


export const RouteTable: Routes[] = [
  {
    path: '/',
    component: LayoutPage
  },
  {
    path: '/login',
    component: lazy(() => import('@/pages/login'))
  },
  {
    path: '/joe',
    component: LayoutPage,
    children: [
      {
        path: 'home',
        component: lazy(() => import('@/pages/home'))
      },
      {
        path: 'company',
        component: lazy(() => import('@/pages/company')),
      },
      {
        path: 'types',
        component: lazy(() => import('@/pages/types')),
      },
      {
        path: 'info',
        component: lazy(() => import('@/pages/info')),
      },
      {
        path: 'banner',
        component: lazy(() => import('@/pages/homeBanner')),
      },
      {
        path: 'course/list',
        component: lazy(() => import('@/pages/course/list')),
      },
      {
        path: 'course/category',
        component: lazy(() => import('@/pages/course/category')),
      },
      {
        path: 'course/banner',
        component: lazy(() => import('@/pages/course/banner')),
      },
      {
        path: 'course/application',
        component: lazy(() => import('@/pages/course/application')),
      },
      {
        path: 'user',
        component: lazy(() => import('@/pages/user')),
      },
      {
        path: 'share',
        component: lazy(() => import('@/pages/shareInfo')),
      },
      {
        path: 'certificate',
        component: lazy(() => import('@/pages/uploadCertificate')),
      }
    ]
  },
  {
    path: '*',
    component: NotFoundPage
  }
];